import React, { useEffect, useState } from 'react';
import { Card, Form, Button, Row, Col, Spin, Table } from 'antd';
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage';
import BaseListing from 'src/BaseListings';
import WidgetSelector from 'src/widgets/Selectors/WidgetSelector';
import { VOUCHER_STATUS_DROPDOWN_OPTIONS } from 'src/models/vouchers';
import WidgetProjectSelector from 'src/widgets/Selectors/WidgetProjectSelector';
import { wtApiCall, wtApiPostWithContentTypeHandling } from 'src/helpers/commons/ApiWrapper';
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications';
import { wtFormatMoney } from 'src/helpers/commons/utils';
import { wtSubYearsToDate } from 'src/helpers/commons/moment';
import WidgetDatePicker from 'src/widgets/DatePickers/WidgetDatePicker';
import { TYPE_GROUP, TYPE_TOTAL } from 'src/models/pnlConfig';
import { CaretDownFilled, CaretRightFilled, FilePdfOutlined, FileExcelOutlined } from '@ant-design/icons'
import WidgetBranchMultiSelector from 'src/widgets/Multi-Selectors/WidgetBranchMultiSelector';
import './GrossProfitSheet.css';

const GrossProfitSheet = () => {
    const Base = new BaseListing('gross_profit_sheet')
    const [isLoading, setIsLoading] = useState(false)
    const [form] = Form.useForm();

    const [projects, setProjects] = useState([])
    const branches = wtGetFromLocalStorage("branches");

    const [projectId, setProjectId] = useState()
    const [projectName, setProjectName] = useState('')

    const [voucherStatus, setVoucherStatus] = useState()
    const [voucherStatusName, setVoucherStatusName] = useState('')

    const [selectedBranches, setSelectedBranches] = useState([])


    const [grossProfitSheetData, setGrossProfitSheetData] = useState([])
    const [asOf, setAsOf] = useState('')

    const lastYearLastDate = asOf ? wtSubYearsToDate(asOf, 1, "YYYY-MM-DD") : '';

    const companyName = wtGetFromLocalStorage("company_name");

    const [boldRows, setBoldRows] = useState([]);
    const [expandedRows, setExpandedRows] = useState([]);

    // Define columns of gross profit sheet
    const [grossProfitSheetHeaderColumns, setGrossProfitSheetHeaderColumns] = useState([]);


    const getLink = (record, text, key) => {
        return wtFormatMoney(text, "", true, 2);
        let fromDate = "2000-01-01";
        let toDate = "";

        if (key === 'asof') {
            toDate = asOf;
        }

        if (key === 'last') {
            toDate = lastYearLastDate;
        }

        if (record.type === TYPE_TOTAL) {

            if (record.type === TYPE_TOTAL && record.link_to_surcharge === 1) {
                const queryParams = "asOf=" + asOf + "&lastYearLastDate=" + lastYearLastDate + "&voucherStatus=" + (+voucherStatus) + "&branchId=" + (+branchId) + "&branchName=" + branchName + "&projectId=" + (+projectId) + " ";
                return (
                    <a href={'/reports?' + queryParams + '#code:profit-and-loss-surcharge'}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", color: "#000000" }}
                    >
                        {wtFormatMoney(text, "", true, 2)}
                    </a>
                );
            }

            return wtFormatMoney(text, "", true, 2);
        }
        else {
            if (record.source_id) {
                const queryParams = "fromDate=" + fromDate + "&toDate=" + toDate + "&accountId=" + (+record.source_id) + "&voucherStatus=" + (+voucherStatus) + "&branchId=" + (+branchId) + "&branchName=" + branchName + "&projectId=" + (+projectId) + " ";
                return (
                    <a href={'/reports?' + queryParams + '#code:account-statement'}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", color: "#000000" }}
                    >
                        {wtFormatMoney(text, "", true, 2)}
                    </a>
                )
            }
            return wtFormatMoney(text, "", true, 2);
        }
    }

    const changeValues = (key, val) => {

        //Set initial values
        setGrossProfitSheetData([]);

        if (key === 'branch_id') {
            setSelectedBranches(val);

            let columns = [];
            if (val.length > 0) {
                columns.push(
                    {
                        title: <span style={{ fontSize: '0.8rem', marginLeft: '5%' }}>Account Description</span>,
                        dataIndex: 'name',
                        key: 'name',
                        align: 'left',
                        fixed: 'left',
                        width: 800,
                        onCell: (record) => ({
                            onClick: () => handleExpand(record),
                            style: { cursor: 'pointer' }
                        }),
                        render: (text, record) => (
                            <span style={{
                                fontWeight: (record.type === TYPE_TOTAL || boldRows.includes(record.key)) ? 'bold' : 'normal',
                                fontSize: (record.type === TYPE_TOTAL) ? "0.83rem" : "0.8rem",
                                cursor: "pointer"
                            }}>
                                {text}
                            </span>
                        )
                    }
                );

                for (let i = 0; i < val.length; i++) {
                    columns.push(
                        {
                            title: <span style={{ fontSize: '0.8rem' }}>{val[i].label}</span>,
                            align: 'right',
                            width: 160,
                            children: [
                                {
                                    title: <span style={{ fontSize: '0.8rem' }}>Balance ( .Rs. )</span>,
                                    dataIndex: "current_year_balance_" + val[i].value,
                                    key: i + "current_year_balance_" + val[i].value,
                                    align: 'right',
                                    render: (text, record) => (
                                        <span style={{
                                            fontWeight: (record.type === TYPE_TOTAL || boldRows.includes(record.key)) ? 'bold' : 'normal',
                                            fontSize: (record.type === TYPE_TOTAL) ? "0.83rem" : "0.8rem",
                                        }}>
                                            {getLink(record, text, 'asof')}
                                        </span>
                                    ),
                                }
                            ]
                        }
                    );
                }

                //Push Total Row
                columns.push(
                    {
                        title: <span style={{ fontSize: '0.8rem' }}>Total </span>,
                        align: 'right',
                        width: 160,
                        children: [
                            {
                                title: <span style={{ fontSize: '0.8rem' }}>Balance ( .Rs. )</span>,
                                dataIndex: "total",
                                key: "total",
                                align: 'right',
                                render: (text, record) => (
                                    <span style={{
                                        fontWeight: (record.type === TYPE_TOTAL || boldRows.includes(record.key)) ? 'bold' : 'normal',
                                        fontSize: (record.type === TYPE_TOTAL) ? "0.83rem" : "0.8rem",
                                    }}>
                                        {getLink(record, text, 'asof')}
                                    </span>
                                ),
                            }
                        ]
                    }
                );
            }
            setGrossProfitSheetHeaderColumns(columns);
        }
        if (key === 'project_id') {
            setProjectId(val)
            if (val === '') {
                setProjectName('');
            }
        }
        if (key === 'voucher_status') {
            setVoucherStatus(val.value)
            setVoucherStatusName(val.label)
        }
        if (key === 'as_of') {
            setAsOf(val);
        }
    }


    useEffect(() => {
        Base.dropdownData('projects', {}, [setProjects], 1)
    }, [])


    const getReportData = () => {
        setIsLoading(true);
        wtApiCall(
            'reports/gross_profit_sheet',
            {
                as_of: asOf,
                last_year: lastYearLastDate,
                branch_id: selectedBranches,
                project_id: projectId,
                voucher_status: voucherStatus,
                version: 2
            },
            'get',
            (response) => {

                //set data
                if (response !== null) {
                    if (response.data !== null) {
                        if (response.data.hasOwnProperty('gross_profit_sheet_data')) {
                            setGrossProfitSheetData(response.data.gross_profit_sheet_data);
                        }
                        else {
                            //Set initial values
                            setGrossProfitSheetData([]);
                        }
                    }
                }

                setIsLoading(false);
            },
            (error) => {
                lzNotifyErrorMessageFromResult(error);
                setIsLoading(false);
            },
        );

    };

    const expandIcon = ({ expanded, onExpand, record }) => {
        if (record.hasItems && record.type === TYPE_GROUP) {
            return (
                <span style={{ marginRight: '2%' }}>
                    {expanded ? (
                        <CaretDownFilled style={{ color: "#706f71", fontSize: 12 }} onClick={(e) => onExpand(record, e)} />
                    ) : (
                        <CaretRightFilled style={{ color: "#706f71", fontSize: 12 }} onClick={(e) => onExpand(record, e)} />
                    )}
                </span>
            )
        } else {
            return <span style={{ marginRight: '3%' }}></span>
        }
    };

    const handleExpand = (record) => {
        const key = record.key;
        if (record.type === TYPE_GROUP && record.hasItems) {
            setExpandedRows((prevExpandedRows) => {
                const isExpanded = prevExpandedRows.includes(key);
                if (isExpanded) {
                    return prevExpandedRows.filter(rowKey => rowKey !== key);
                } else {
                    return [...prevExpandedRows, key];
                }
            });

            setBoldRows((prevBoldRows) => {
                const isBold = prevBoldRows.includes(key);
                if (isBold) {
                    return prevBoldRows.filter(rowKey => rowKey !== key);
                } else {
                    return [...prevBoldRows, key];
                }
            });
        }
    };

    const exportToExcel = () => {
        setIsLoading(true);
        wtApiPostWithContentTypeHandling('reports/gross_profit_sheet/export', { data: grossProfitSheetData, asOf: asOf, lastYearLastDate: lastYearLastDate });
        setIsLoading(false);
    }

    const exportToPdf = async () => {
        setIsLoading(true);
        try {
            // Simulate a delay to mimic PDF generation
            await new Promise(resolve => setTimeout(resolve, 2000));
            Pdf(grossProfitSheetData, asOf, lastYearLastDate);
        } catch (error) {
            console.error("Failed to generate PDF", error);
        }
        setIsLoading(false);
    };


    return (
        <div className='container-fluid' style={{
            padding: "1em", backgroundColor: "white", minHeight: "100vh", fontFamily: "Helvetica",
        }}>
            <Form
                layout={'vertical'}
                form={form}
                onFinish={getReportData}
                style={{ maxWidth: "100%", margin: '0 auto' }}
            >
                <Card title={<span style={{ fontSize: '22px', marginLeft: "40%" }}>{companyName + " Profit & Loss Vertical"}</span>} style={{ width: "100%" }}>
                    <Row gutter={[16, 16]}>
                        <Col xs={15} sm={10} md={4}>
                            <label>As Of: *</label>
                            <WidgetDatePicker
                                value={asOf}
                                setDate={setAsOf}
                                placeholder="As Of"
                            />
                        </Col>
                        <Col xs={18} sm={12} md={11}>
                            <label className='branch-multi-select'>Branch: *</label>
                            <WidgetBranchMultiSelector
                                Branches={branches}
                                onChange={(values) => changeValues("branch_id", values)}
                                value={selectedBranches}
                            />

                        </Col>
                        <Col xs={12} sm={8} md={3}>
                            <label>Voucher Status:</label>
                            <WidgetSelector
                                selectedValue={voucherStatus}
                                displayValue={voucherStatusName}
                                options={VOUCHER_STATUS_DROPDOWN_OPTIONS}
                                showCloudIcon={false}
                                size={"md"}
                                onChange={(values) => changeValues("voucher_status", values)}
                            />
                        </Col>
                        <Col xs={18} sm={12} md={4}>
                            <label>Project: </label>
                            <WidgetProjectSelector
                                onChange={(value) => changeValues('project_id', value)}
                                data={projects}
                                value={projectId}
                                displayValue={projectName}
                                height={35}
                                reloadDropdownData={() => Base.dropdownData('projects', {}, [setProjects], 1)}
                            />
                        </Col>

                        <Col xs={8} sm={4} md={2}>
                            <Button style={{ marginTop: 35 }} type="primary" htmlType="submit" disabled={isLoading ? true : false}>Search</Button>
                        </Col>
                    </Row>
                </Card>

                <br /><br />
                <div style={{ overflow: 'auto', margin: "auto", width: "100%" }}>
                    {/* {Base.hasRights('Export Gross Profit Sheet') &&
                        <Button style={{ marginBottom: 10, float: "right", backgroundColor: "#FF0000", color: "#fff" }} onClick={exportToPdf} disabled={isLoading ? true : false} icon={<FilePdfOutlined />}></Button>
                    }
                    {Base.hasRights('Export Gross Profit Sheet') &&
                        <Button style={{ marginBottom: 10, float: "right", backgroundColor: "#28A745", color: "#fff" }} onClick={exportToExcel} disabled={isLoading ? true : false} icon={<FileExcelOutlined />}></Button>
                    } */}

                    {grossProfitSheetHeaderColumns.length > 0 &&
                        <Table
                            columns={grossProfitSheetHeaderColumns}
                            dataSource={grossProfitSheetData}
                            pagination={false}
                            expandable={{ expandedRowKeys: expandedRows, expandIcon: expandIcon }}
                            scroll={{ x: ((selectedBranches.length * 160) + 800 + 160), y: 600 }}
                            // virtual={true}
                            bordered
                            size="small"
                            loading={{ indicator: <div><Spin /></div>, spinning: isLoading }}
                        />
                    }
                </div>

            </Form >
        </div >
    );
};

export default GrossProfitSheet;
